import React from 'react';
import { I18n } from '../../../helpers/i18n';
import RatingStarsDisplay from './RatingStarsDisplay';
import ratingUserAvatar from '../../../static/images/mvp/rating-user-avatar.png';
import { formatSessionDateDashed } from '../../pages/app/mvp/helper';
import './RatingListItem.css';

function RatingListItem({
  roleLabel,
  name,
  score,
  time,
  sessionTitle,
  contentExtra,
  content,
}) {
  const tags = content ? (Array.isArray(content) ? content : [content]) : [];

  return (
    <div className="rating-list-item">
      <div className="rating-list-item-header">
        <div className="rating-list-item-avatar-wrapper">
          <div className="rating-list-item-avatar">
            <img src={ratingUserAvatar} alt="rating-user-avatar" />
          </div>
          <span className="rating-list-item-role">{roleLabel}</span>
        </div>
        <div className="rating-list-item-info">
          <span className="rating-list-item-name">{name}</span>
          <div className="rating-list-item-meta">
            <RatingStarsDisplay
              score={score}
              size={14}
              activeColor="#F59E0B"
              inactiveColor="#4B5563"
            />
            {time && (
              <span className="rating-list-item-date">
                {formatSessionDateDashed(time)}
              </span>
            )}
          </div>
        </div>
      </div>
      {sessionTitle && (
        <p className="rating-list-item-session-line">
          {I18n.t('session_label')}: {sessionTitle}
        </p>
      )}
      {contentExtra && <p className="rating-list-item-comment">{contentExtra}</p>}
      {tags.length > 0 && (
        <div className="rating-list-item-tags">
          {tags.map((tag, i) => (
            <span key={i} className="rating-list-item-tag">
              {tag}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}

export default RatingListItem;
